export interface SliceItemUpdateProps<T extends { id: string }> {
  item: T;
  arr: T[];
}

export const sliceItemUpdate = <T extends { id: string }>({ item, arr }: SliceItemUpdateProps<T>): T[] => {
  const index = arr.findIndex((arrItem) => arrItem.id === item.id);
  return index > -1 ? [...arr.slice(0, index), item, ...arr.slice(index + 1)] : arr;
};

export interface SliceItemRemoveProps<T> {
  index: number;
  arr: T[];
}
export const sliceItemRemove = <T extends { id: string }>({ item, arr }: SliceItemUpdateProps<T>): T[] => {
  const index = arr.findIndex((arrItem) => arrItem.id === item.id);
  return index > -1 ? [...arr.slice(0, index), ...arr.slice(index + 1)] : arr;
};
